const CATEGORIES = {
  all: {}, analytics: {}, backend: {}, database: {}, automation: {},
  auth: {}, payments: {}, ai: {}, messaging: {}, storage: {},
  observability: {}, ui: {}, system: {}, starter: {}, marketing: {},
  docs: {}, commerce: {}, content: {}, quality: {}, editor: {},
  domains: {}
}

export const MarketplaceFilters = {
  flow: 'x',
  gap: 'Y',
  padding: 'Y A',
  overflow: 'x auto',
  borderBottom: '1px solid line',

  childExtends: 'MarketplaceCategoryItem',
  children: CATEGORIES
}
